module.exports = __webpack_public_path__ + "img/forward.6568c6cc.svg";